import { render, staticRenderFns } from "./TopOptBar.vue?vue&type=template&id=4f84efc6&scoped=true&"
import script from "./TopOptBar.vue?vue&type=script&lang=js&"
export * from "./TopOptBar.vue?vue&type=script&lang=js&"
import style0 from "./TopOptBar.vue?vue&type=style&index=0&id=4f84efc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f84efc6",
  null
  
)

export default component.exports